(() => {
  const root = document.documentElement;
  let scheduled = false;
  const visible = element => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };
  const overlaps = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  const update = () => {
    scheduled = false;
    const host = document.querySelector('shopify-chat');
    const runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    const activator = runtime?.shadowRoot?.querySelector('[part="activator"]');
    if (!activator) return;
    const banner = document.getElementById('shopify-pc__banner');
    const preferences = document.getElementById('shopify-pc__prefs');
    const consentOpen = visible(banner) || visible(preferences);
    const bounds = activator.getBoundingClientRect();
    const controls = document.querySelectorAll('main a, main button, main input, footer a, footer button, footer input');
    const blocksControl = Array.from(controls).some(control => visible(control) && overlaps(bounds, control.getBoundingClientRect()));
    const chatOpen = activator.getAttribute('aria-expanded') === 'true';
    root.classList.toggle('lsr-chat-obstructed', !chatOpen && (consentOpen || blocksControl));
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  };
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'aria-hidden']});
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('visitorConsentCollected', schedule);
  customElements.whenDefined('shopify-chat').then(() => {
    schedule();
    setTimeout(schedule, 500);
    setTimeout(schedule, 1500);
    setTimeout(schedule, 4000);
  });
  schedule();
})();